<div class="flow-conditions">
  <p class="flow-conditions-help text-muted small">
    <i class="fa-solid fa-circle-info me-1"></i>
    <span translate>FLOW_CONDITIONS_HELP</span>
  </p>

  @if (flowProductConditions.length === 0) {
    <div class="flow-conditions-empty text-muted text-center border rounded p-4 mb-2">
      <i class="fa-solid fa-filter-circle-xmark fa-lg mb-2 d-block"></i>
      <span translate>FLOW_CONDITIONS_EMPTY</span>
    </div>
  }

  @for (group of flowProductConditions; track $index; let index = $index) {
    @if (index > 0) {
      <div class="group-joiner text-center my-3">
        <span class="badge rounded-pill group-joiner-badge" translate>OR</span>
      </div>
    }

    <div class="card rule-group mb-2">
      <div class="card-header d-flex align-items-center">
        <span class="fw-bold"><span translate>FLOW_RULE_GROUP</span> {{ index + 1 }}</span>
        <span class="ms-2 small text-muted d-none d-sm-inline" translate>FLOW_RULE_GROUP_ALL_MUST_MATCH</span>
        <button
          type="button"
          class="btn btn-link text-danger ms-auto p-0"
          title="{{ 'DELETE' | translate }}"
          (click)="delete(index)"
        >
          <i class="fa-solid fa-trash-can"></i>
        </button>
      </div>

      <div class="card-body">
        @if (visibleSettings(index).length === 0) {
          <div class="alert alert-warning py-2 px-3 mb-3 small">
            <i class="fa-solid fa-triangle-exclamation me-1"></i>
            <span translate>FLOW_RULE_GROUP_EMPTY_WARNING</span>
          </div>
        }

        @for (setting of visibleSettings(index); track setting.label; let ruleIndex = $index) {
          @if (ruleIndex > 0) {
            <div class="rule-joiner my-1">
              <span class="badge rounded-pill rule-joiner-badge" translate>AND</span>
            </div>
          }

          <div class="rule">
            <div class="rule-field" [title]="setting.label">{{ displayName(setting) }}</div>

            <select
              class="form-select form-select-sm rule-operator"
              [attr.aria-label]="'FLOW_CONDITION_OPERATOR' | translate"
              (change)="setOperator($any($event.target).value, setting, index)"
            >
              @for (operator of operators; track operator) {
                <option [value]="operator" [selected]="operator === setting.entry.key">
                  {{ operatorLabels[operator] | translate }}
                </option>
              }
            </select>

            <div class="rule-values form-control form-control-sm" (click)="valueInput.focus()">
              @for (value of valuesOf(setting); track value) {
                <span class="value-chip">
                  {{ value }}
                  <button
                    type="button"
                    class="value-chip-remove"
                    [attr.aria-label]="'DELETE' | translate"
                    (click)="removeValue(value, setting, index); $event.stopPropagation()"
                  >
                    <i class="fa-solid fa-xmark"></i>
                  </button>
                </span>
              }
              <input
                #valueInput
                type="text"
                class="value-input"
                [placeholder]="valuesOf(setting).length === 0 ? ('FLOW_CONDITION_ADD_VALUE' | translate) : ''"
                (input)="onValueInput($any($event.target).value, setting, index)"
                (keydown)="onValueKeydown($event, setting, index)"
                (blur)="onValueBlur($event, setting, index)"
                (paste)="onValuePaste($event, setting, index)"
              />
            </div>

            <button
              type="button"
              class="btn btn-link text-danger rule-remove p-0"
              title="{{ 'DELETE' | translate }}"
              (click)="removeRule(index, setting)"
            >
              <i class="fa-solid fa-xmark"></i>
            </button>
          </div>
        }

        <div ngbDropdown #picker="ngbDropdown" class="d-inline-block mt-3" autoClose="outside" (openChange)="pickerFilter[index] = ''">
          <button type="button" class="btn btn-outline-primary btn-sm" ngbDropdownToggle>
            <i class="fa-solid fa-plus me-1"></i>
            <span translate>FLOW_CONDITION_ADD_RULE</span>
          </button>
          <div ngbDropdownMenu class="rule-picker">
            <div class="px-2 pb-2">
              <input
                type="text"
                class="form-control form-control-sm"
                [placeholder]="'SEARCH' | translate"
                [value]="pickerFilter[index]"
                (input)="pickerFilter[index] = $any($event.target).value"
              />
            </div>
            <div class="rule-picker-list">
              @for (setting of filteredAvailableSettings(index); track setting.label) {
                <button ngbDropdownItem type="button" (click)="addRule(index, setting); picker.close()">
                  {{ displayName(setting) }}
                </button>
              }
              @if (filteredAvailableSettings(index).length === 0) {
                <span class="dropdown-item-text text-muted small" translate>FLOW_CONDITION_NO_MORE_FIELDS</span>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  }

  <button type="button" class="btn btn-primary w-100 mt-2" (click)="add()">
    <i class="fa-solid fa-plus me-1"></i>
    <span translate>FLOW_CONDITION_ADD_GROUP</span>
  </button>
</div>
